<div class="container">
  <div class="redeem-container d-flex flex-column position-relative">
    <section>
      <app-card-banner></app-card-banner>
      <!-- Offers Carousel -->
      @if (hasCardOffers) {
      <div
        class="d-flex flex-column align-items-center position-relative offer-mt"
      >
        <div
          class="offer-carousel align-items-center text-center text-md-start position-relative"
        >
          @if (cardMemberOffers.length > 1) {
          <button
            class="arrow left d-none d-md-flex"
            (click)="prevSlide()"
            [disabled]="currentIndex === 0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="23"
              viewBox="0 0 14 23"
              fill="none"
            >
              <path
                d="M10.3883 0.751121C11.0374 0.0700591 12.1242 0.0700599 12.7734 0.751122C13.38 1.38753 13.38 2.38813 12.7734 3.02455L4.69497 11.5L12.7734 19.9754C13.38 20.6119 13.38 21.6125 12.7734 22.2489C12.1242 22.9299 11.0374 22.9299 10.3883 22.2489L1.09526 12.4995C0.561882 11.9399 0.561883 11.0601 1.09526 10.5005L10.3883 0.751121Z"
                fill="white"
              />
            </svg>
          </button>
          }

          <div
            class="d-flex flex-column flex-md-row align-items-center justify-content-center align-items-md-start offer-gap pointer"
            (click)="openOfferModal()"
          >
            <div class="offer-img-container">
              <img
                [src]="currentOffer.offerCard.image"
                alt="{{ currentOffer.offerCard.imageAlt }}"
                class="offer-img"
              />
            </div>
            <div class="d-flex flex-column gap-12">
              <div
                class="gb-headline3 heavy"
                [innerHTML]="currentOffer.offerCard.title"
              ></div>
              <div class="gb-headline6 heavy">
                {{ currentOffer.offerCard.subTitle }}
              </div>
              <div
                class="gb-body1"
                [innerHTML]="currentOffer.offerCard.body"
              ></div>
            </div>
          </div>

          @if (cardMemberOffers.length > 1) {
          <button
            class="arrow right d-none d-md-flex"
            (click)="nextSlide()"
            [disabled]="currentIndex === cardMemberOffers.length - 1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="23"
              viewBox="0 0 14 23"
              fill="none"
            >
              <path
                d="M3.61174 22.2489C2.96256 22.9299 1.87581 22.9299 1.22663 22.2489C0.620013 21.6125 0.620005 20.6119 1.22661 19.9754L9.30503 11.5L1.22661 3.02456C0.620005 2.38814 0.620013 1.38754 1.22663 0.751125C1.87581 0.0700645 2.96256 0.0700645 3.61174 0.751125L12.9047 10.5005C13.4381 11.0601 13.4381 11.9399 12.9047 12.4995L3.61174 22.2489Z"
                fill="white"
              />
            </svg>
          </button>
          }
        </div>

        <!-- Offer Cards Pagination Dots -->
        @if (cardMemberOffers.length > 1) {
        <div class="dots d-flex flex-md-row align-items-center">
          <button
            class="arrow d-flex d-md-none"
            (click)="prevSlide()"
            [disabled]="currentIndex === 0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="30px"
              viewBox="0 0 320 512"
              transform="scale(-1 1)"
            >
              <path
                fill="#ffffff"
                d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
              />
            </svg>
          </button>

          <div class="d-flex gap-10">
            @for (offer of cardMemberOffers; track offer.offerId; let idx =
            $index) {
            <span
              [class.active]="idx === currentIndex"
              (click)="goToSlide(idx)"
            >
            </span>
            }
          </div>

          <button
            class="arrow d-flex d-md-none"
            (click)="nextSlide()"
            [disabled]="currentIndex === cardMemberOffers.length - 1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="30px"
              viewBox="0 0 320 512"
            >
              <path
                fill="#ffffff"
                d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
              />
            </svg>
          </button>
        </div>
        }
      </div>
      }
    </section>

    <!-- Redeem Section-->
    <section>
      <div class="d-flex flex-column align-items-center text-center">
        <div
          class="gb-headline1 heavy mb-18"
          [innerHTML]="$safeNavigationMigration(aemContent?.buySectionHeader)"
        ></div>
        <div
          class="gb-body1 gb-headline5 mb-24-18"
          [innerHTML]="$safeNavigationMigration(aemContent?.buySectionBody)"
        ></div>
        <div
          class="gb-body1 disc-mb"
          [innerHTML]="$safeNavigationMigration(aemContent?.buySectionSubBody)"
        ></div>
      </div>

      <!-- Redeem Carousel -->
      <div
        class="d-flex align-items-center position-relative w-100 mr-minus-30"
      >
        <button
          class="arrow left z-1 d-none d-md-flex"
          (click)="scrollLeft()"
          [disabled]="currentPage === 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 0 320 512"
            transform="scale(-1 1)"
          >
            <path
              fill="#ffffff"
              d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
            />
          </svg>
        </button>

        <div class="carousel mr-minus-30" #carousel (scroll)="handleScroll()">
          @for (tile of tiles; track tile.title) {
          <div
            (click)="openRedeemModal(tile)"
            class="card stat-image-link"
            data-dtm="your points"
            #cardEl
            [ngStyle]="{ 'background-image': 'url(' + tile.image + ')' }"
          >
            <div
              class="d-flex justify-content-end"
              [innerHTML]="tile.icon | safeHtml"
            ></div>
            <div
              class="gb-headline4 white-text"
              [innerHtml]="$safeNavigationMigration(tile?.title)"
            ></div>
          </div>
          }
        </div>

        <button
          class="arrow right d-none d-md-flex"
          (click)="scrollRight()"
          [disabled]="currentPage >= totalPages - 1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 0 320 512"
          >
            <path
              fill="#ffffff"
              d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
            />
          </svg>
        </button>
      </div>

      <!-- Redeem Carousel - Pagination Dots -->
      <div
        class="dots d-flex flex-md-row align-items-center justify-content-center"
      >
        <button
          class="arrow left z-1 d-flex d-md-none"
          (click)="scrollLeft()"
          [disabled]="currentPage === 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 0 320 512"
            transform="scale(-1 1)"
          >
            <path
              fill="#ffffff"
              d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
            />
          </svg>
        </button>

        <div class="d-flex gap-10">
          @for (page of paginationArray; track $index ) {
          <span
            class="dot"
            [class.active]="$index === currentPage"
            (click)="goToPage($index)"
          >
          </span>
          }
        </div>

        <button
          class="arrow d-flex d-md-none"
          (click)="scrollRight()"
          [disabled]="currentPage >= totalPages - 1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 0 320 512"
          >
            <path
              fill="#ffffff"
              d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
            />
          </svg>
        </button>
      </div>
    </section>

    <!-- How GMB Mastercard works/Locate Dealer Section -->
    <section>
      <div class="d-flex justify-content-center gb-headline1 heavy text-center">
        {{ aemContent.header1 }}
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-center align-items-center mc-spacing"
      >
        <div class="d-flex flex-column align-items-center icon-spacing">
          <div class="icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <g clip-path="url(#clip0_6035_89098)">
                <path
                  d="M44.2945 26.5383C41.8941 24.1484 38.7205 22.8331 35.3615 22.8331C28.3939 22.8331 22.7231 28.4792 22.7231 35.4246C22.7231 42.3699 28.3939 48.008 35.3615 48.008C42.3291 48.008 48.0079 42.4822 48.0079 35.4246C48.0079 32.0882 46.695 28.9363 44.3026 26.5464L44.2945 26.5383Z"
                  fill="#33302B"
                />
                <path
                  d="M34.1452 44.391V42.5704C33.1947 42.3378 32.4054 41.9128 31.769 41.2792C31.1327 40.6456 30.6574 39.8757 30.3433 38.9694L32.7678 38.0872C33.0498 38.7128 33.4445 39.2341 33.9358 39.6431C34.4352 40.0521 34.991 40.2526 35.6032 40.2526C36.2154 40.2526 36.7229 40.0922 37.0853 39.7875C37.4478 39.4747 37.6331 39.0336 37.6331 38.4642C37.6331 38.0471 37.5123 37.7023 37.2787 37.4135C37.037 37.1328 36.7229 36.8842 36.3121 36.6837C35.9012 36.4832 35.4502 36.2747 34.9588 36.0902C34.4755 35.8977 33.9922 35.6972 33.5089 35.4727C33.0256 35.2481 32.5906 34.9754 32.1959 34.6627C31.8012 34.3499 31.4871 33.9569 31.2454 33.4837C31.0038 33.0105 30.883 32.4411 30.883 31.7514C30.883 30.8932 31.1568 30.1153 31.7126 29.4256C32.2684 28.7358 33.0659 28.2947 34.105 28.0942V26.4662H36.6987V28.1103C37.5284 28.3108 38.1969 28.6877 38.7125 29.2331C39.2199 29.7784 39.5905 30.412 39.8079 31.1419L37.4236 31.9358C37.2545 31.5348 36.9887 31.19 36.6343 30.8932C36.2798 30.5965 35.8126 30.4521 35.2488 30.4602C34.7252 30.4602 34.3225 30.5724 34.0405 30.797C33.7586 31.0216 33.6136 31.3343 33.6136 31.7514C33.6136 32.0802 33.7264 32.3609 33.96 32.5855C34.1936 32.81 34.4916 33.0185 34.8702 33.195C35.2488 33.3714 35.6596 33.5479 36.1107 33.7163C36.5859 33.8927 37.0692 34.0932 37.5606 34.3258C38.0519 34.5584 38.5111 34.8471 38.938 35.2C39.3649 35.5529 39.7032 35.986 39.969 36.5153C40.2349 37.0446 40.3637 37.6862 40.3637 38.4481C40.3637 39.21 40.2107 39.9158 39.8885 40.5013C39.5743 41.0867 39.1394 41.5679 38.5836 41.9288C38.0358 42.2977 37.4156 42.5383 36.7309 42.6667V44.415H34.1372L34.1452 44.391Z"
                  fill="white"
                />
                <path
                  d="M9.73049 14.8772C4.36583 14.8772 0 19.2241 0 24.5734C0 29.9228 4.36583 34.2697 9.73049 34.2697C15.0951 34.2697 19.469 30.011 19.469 24.5815C19.469 22.007 18.4622 19.585 16.6176 17.7484C14.7729 15.9038 12.3242 14.8932 9.73855 14.8932L9.73049 14.8772Z"
                  fill="#33302B"
                />
                <path
                  d="M8.84435 32V30.5002C8.06301 30.3078 7.41055 29.9549 6.88697 29.4336C6.3634 28.9123 5.97675 28.2787 5.71094 27.5328L7.70859 26.803C7.94218 27.3163 8.26439 27.7414 8.67519 28.0782C9.086 28.415 9.54514 28.5835 10.0526 28.5835C10.5601 28.5835 10.9709 28.4551 11.277 28.1985C11.575 27.9419 11.7281 27.581 11.7281 27.1078C11.7281 26.7629 11.6314 26.4742 11.4381 26.2416C11.2448 26.009 10.9789 25.8085 10.6406 25.6401C10.3023 25.4717 9.93178 25.3033 9.52903 25.1509C9.12628 24.9985 8.73158 24.8221 8.33688 24.6376C7.94218 24.4531 7.57971 24.2286 7.25751 23.9719C6.9353 23.7153 6.66949 23.3865 6.47617 23.0015C6.27479 22.6165 6.17813 22.1434 6.17813 21.5739C6.17813 20.8682 6.40367 20.2266 6.86281 19.6652C7.32195 19.0957 7.98246 18.7268 8.83629 18.5664V17.2271H10.9789V18.5825C11.6636 18.7509 12.2194 19.0556 12.6383 19.5048C13.0571 19.9539 13.3632 20.4752 13.5404 21.0767L11.5831 21.7263C11.4381 21.3975 11.2206 21.1088 10.9306 20.8682C10.6406 20.6276 10.254 20.5073 9.78679 20.5073C9.35987 20.5073 9.02156 20.6035 8.78796 20.78C8.55437 20.9564 8.43354 21.2211 8.43354 21.5659C8.43354 21.8386 8.5302 22.0632 8.71547 22.2556C8.90073 22.4481 9.1585 22.6085 9.46459 22.7529C9.77068 22.8972 10.117 23.0416 10.4876 23.1779C10.8742 23.3223 11.277 23.4907 11.6797 23.6832C12.0825 23.8757 12.4611 24.1083 12.8155 24.397C13.1699 24.6857 13.4518 25.0466 13.6613 25.4797C13.8788 25.9128 13.9835 26.4421 13.9835 27.0757C13.9835 27.7093 13.8546 28.2867 13.5968 28.7679C13.3391 29.2491 12.9766 29.6421 12.5255 29.9469C12.0744 30.2516 11.5589 30.4521 11.0031 30.5484V31.984H8.86851L8.84435 32Z"
                  fill="white"
                />
                <path
                  d="M31.9062 7.44261C31.9062 5.46967 31.1329 3.60902 29.7152 2.19749C28.2976 0.785965 26.4207 0.00801992 24.4311 0.00801992C20.307 0.00801992 16.9561 3.34436 16.9561 7.44261C16.9561 11.5409 20.307 14.8852 24.4311 14.8852C28.5553 14.8852 31.8982 11.613 31.8982 7.45063L31.9062 7.44261Z"
                  fill="#33302B"
                />
                <path
                  d="M23.7142 12.7439V11.6692C23.1503 11.5328 22.6831 11.2762 22.3126 10.9073C21.942 10.5383 21.6601 10.0812 21.4668 9.54386L22.9006 9.02256C23.0698 9.39148 23.2953 9.69624 23.5933 9.93684C23.8833 10.1774 24.2136 10.2977 24.5841 10.2977C24.9546 10.2977 25.2446 10.2015 25.4621 10.0251C25.6796 9.8406 25.7843 9.57594 25.7843 9.2391C25.7843 8.99048 25.7118 8.78997 25.5749 8.62155C25.4379 8.45313 25.2446 8.30877 25.003 8.18847C24.7613 8.06817 24.4955 7.94787 24.2055 7.83559C23.9155 7.72331 23.6336 7.60301 23.3517 7.46667C23.0698 7.33033 22.812 7.17794 22.5784 6.98546C22.3448 6.801 22.1595 6.56842 22.0145 6.28772C21.8695 6.00702 21.7971 5.67018 21.7971 5.26917C21.7971 4.76391 21.9582 4.30677 22.2884 3.89774C22.6187 3.48872 23.0859 3.22406 23.7061 3.11178V2.14937H25.2446V3.1198C25.736 3.2401 26.1307 3.45664 26.4368 3.78546C26.7428 4.11429 26.9523 4.48321 27.0892 4.91629L25.6796 5.38145C25.5749 5.14085 25.4218 4.94035 25.2124 4.76391C25.003 4.58747 24.7291 4.50727 24.3908 4.50727C24.0847 4.50727 23.843 4.57143 23.6739 4.70777C23.5047 4.84411 23.4161 5.02857 23.4161 5.26917C23.4161 5.46165 23.4886 5.63008 23.6175 5.7584C23.7464 5.88672 23.9316 6.01504 24.1572 6.1193C24.3827 6.22356 24.6244 6.32782 24.8902 6.42406C25.1721 6.52832 25.454 6.64862 25.744 6.78496C26.034 6.9213 26.3079 7.08972 26.5576 7.29825C26.8073 7.50677 27.0087 7.76341 27.1698 8.07619C27.3228 8.38897 27.4034 8.76591 27.4034 9.21504C27.4034 9.66416 27.3148 10.0812 27.1214 10.4261C26.9362 10.7709 26.6784 11.0596 26.3562 11.2682C26.034 11.4847 25.6635 11.6291 25.2607 11.7013V12.7358H23.7222L23.7142 12.7439Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_6035_89098">
                  <rect width="48" height="48" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div
            class="text-center gb-body1"
            [innerHTML]="$safeNavigationMigration(aemContent?.column1Body)"
          ></div>
        </div>
        <div class="d-flex flex-column align-items-center icon-spacing">
          <div class="icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="42"
              viewBox="0 0 48 42"
              fill="none"
            >
              <path
                d="M39.1125 8.89517C39.8175 8.036 40.2165 6.87196 40.2165 5.63401C40.2165 4.23902 39.632 2.88097 38.6115 1.91094C37.6003 0.940908 36.2922 0.442035 34.947 0.497465H28.2211C26.5234 0.497465 24.9277 1.31044 23.9536 2.65001C22.9795 1.31968 21.3931 0.497465 19.6861 0.497465H12.9602C10.0657 0.497465 7.70004 2.80706 7.70004 5.63401C7.70004 6.82577 8.14534 8.00828 8.90607 8.9044H0V20.0182H2.77387V41.5067H45.2261V19.9073H48V8.79354L39.1125 8.88593V8.89517ZM46.2559 10.7706V17.4222C46.2559 17.6347 46.191 17.7733 46.024 17.9396C45.9219 18.0412 45.8477 18.0504 45.523 18.0504H30.828V10.7706H46.2652H46.2559ZM30.8187 39.5389V20.009H43.2594V39.5297H30.8187V39.5389ZM33.5462 8.9044C34.2234 8.1099 34.6316 7.13987 34.7151 6.08669C34.8357 4.71941 34.3997 3.38908 33.5462 2.39134L33.5276 2.36362H34.9563C35.8377 2.31743 36.654 2.6223 37.2849 3.22279C37.9065 3.82329 38.2775 4.6455 38.3239 5.55087C38.3703 6.41928 38.0642 7.24149 37.4612 7.8697C36.8581 8.48868 36.0325 8.85821 35.1419 8.9044H33.5276H33.5462ZM28.8334 10.8722V38.7167C28.8334 38.9015 28.7592 39.6405 28.4345 39.6405H19.8902C19.4356 39.6405 19.1666 39.3726 19.1666 38.92V10.8629H28.8334V10.8722ZM21.959 8.9044C22.2466 8.19305 22.8867 7.62027 23.6846 7.36159H24.2227C25.0205 7.62027 25.6513 8.19305 25.9482 8.9044H21.9683H21.959ZM23.063 5.59706C21.4859 6.10517 20.3262 7.37083 20.0201 8.9044H18.5172C16.6525 8.80278 15.2238 7.42626 15.1125 5.61554C15.1125 3.82329 16.6339 2.36362 18.5079 2.36362H19.7882C21.523 2.36362 22.8775 3.59233 23.0723 5.31067V5.58782L23.063 5.59706ZM24.937 5.44925C25.1225 3.74014 26.5327 2.456 28.2211 2.456H29.5014C31.2826 2.456 32.6741 3.94339 32.6741 5.83726C32.6741 7.45398 31.3104 8.9044 29.7333 9.00603L28.1376 8.9044H27.9613C27.5439 7.30616 26.3935 6.08669 24.937 5.68021V5.45848V5.44925ZM13.1828 5.18133C13.0715 6.5209 13.4797 7.83275 14.3703 8.9044H12.9602C11.0862 8.9044 9.56475 7.42626 9.56475 5.63401C9.56475 3.84176 11.0862 2.37286 12.9602 2.37286H14.361C13.6931 3.16736 13.2756 4.13739 13.1921 5.19057L13.1828 5.18133ZM17.3019 20.009V39.5205H4.7499V20.009H17.3019ZM17.1998 10.7613V18.0412H1.87399V10.7613H17.1998Z"
                fill="#33302B"
              />
            </svg>
          </div>
          <div
            class="text-center gb-body1"
            [innerHTML]="$safeNavigationMigration(aemContent?.column2Body)"
          ></div>
        </div>
      </div>
      <div class="d-flex justify-content-center dealer-btn-mt">
        <button
          class="dealer-btn stat-button-link"
          data-dtm="quick links"
          (click)="goToDealerLocator()"
        >
          {{ aemContent.button1Text}}
        </button>
      </div>
    </section>

    <!-- FAQ's Section -->
    <app-faq></app-faq>
  </div>
</div>

<!-- Buy Tiles Modals -->
<app-modal
  [(visible)]="showRedeemModal"
  [showHeader]="false"
  [modalSize]="'modal-lg'"
>
  <div class="d-flex flex-column modal-gap">
    <div id="modal-body">
      <div
        class="gb-headline4"
        [innerHtml]="$safeNavigationMigration(currentTile?.title)"
      ></div>
    </div>
    <div class="gb-body1">
      <div [innerHtml]="$safeNavigationMigration(currentTile?.body)"></div>
    </div>
    <div class="gb-body3 lh-14">
      <div
        [innerHtml]="$safeNavigationMigration(currentTile?.disclaimer)"
      ></div>
    </div>
  </div>
</app-modal>

<!-- Offers Modals -->
<app-modal
  [(visible)]="showOfferModal"
  [showHeader]="false"
  [modalSize]="'modal-lg'"
>
  <div class="d-flex flex-column modal-gap">
    <div id="modal-body">
      <div
        class="gb-headline4 heavy"
        [innerHTML]="$safeNavigationMigration(currentOffer?.offerModal?.title)"
      ></div>
    </div>
    <div class="gb-body1 cardmember-offers">
      <div
        [innerHtml]="$safeNavigationMigration(currentOffer?.offerModal?.body) | safeHtml"
      ></div>
    </div>
    @if (currentOffer?.offerModal?.disclaimers.length > 0){
    <div class="d-flex flex-column" style="gap: 12px">
      @for (disclaimer of currentOffer?.offerModal?.disclaimers; track $index ){
      <div class="gb-body3 lh-14">
        <div [innerHtml]="disclaimer"></div>
      </div>
      }
    </div>
    }
  </div>
</app-modal>
